import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import Header from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Header';
import formatAmountWithDollar from 'Feature/V2/HbtPortfolioManagement/utils/FormatAmountWithDollar';
import { useTranslation } from 'react-i18next';

const PropertyInfos = ({ arrears }: { arrears: Arrears }) => {
  const { t, i18n } = useTranslation('HbtArrearsInquiryPage');
  return (
    <Grid container spacing={1} flexGrow={1}>
      <Grid size={{ xs: 6, md: 3 }}>
        <Header size="xxsmall">{t('commonInformationSection.propertyAddress')}</Header>
        <Body size="body" textOverflow="wrap" display="flex" flexDirection="column">
          <span>{`${arrears.propertyAddressCivicNumber} ${arrears.propertyAddressStreet}`}</span>
          <span>
            {`${arrears.propertyAddressPostalCode} ${arrears.propertyAddressMunicipality} ${arrears.propertyAddressProvince}`}
          </span>
        </Body>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <Header size="xxsmall">{t('commonInformationSection.referenceNumber')}</Header>
        <Body size="body">{arrears.loanReferenceNumber}</Body>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <Header size="xxsmall">{t('commonInformationSection.lenderCode')}</Header>
        <Body size="body">{arrears.lenderCode}</Body>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <Header size="xxsmall">{t('commonInformationSection.totalLoanAmount')}</Header>
        <Body size="body">
          <>{formatAmountWithDollar(arrears.loanAmount, i18n.language)}</>
        </Body>
      </Grid>
    </Grid>
  );
};

export default PropertyInfos;
